export default function errorReporting(message) {
  return new Error(message);
}
